// extracted by mini-css-extract-plugin
module.exports = {"h5button":"hg","h5Button":"hg","button":"hh","block":"hi","btnDefault":"hj","disable":"hk","btnPrimary":"hl"};